import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';

import {
  SideNavMenuItem,
  SideNavDropdownMenu,
  SideNavSearch,
  SideNavTitle,
} from '@lanl-web/lanl-components';
import { publishedPageMapFilter, useMainHeight } from '../../utils';

import './WMSideNav.scss';

export const WMSideNav = ({ location, setShowMenu }) => {
  const {
    directus: { wm_page_map },
  } = useStaticQuery(graphql`
    query {
      directus {
        wm_page_map(sort: ["sort"]) {
          name
          slug
          status
          sub_pages(sort: ["sort"]) {
            external_link
            link
            slug
            title
            status
          }
        }
      }
    }
  `);

  const [searchText, setSearchText] = useState('');
  const pathNames = location.pathname.split('/');
  pathNames.shift();

  const search = (e) => {
    setSearchText(e.target.value.substr(0, 20));
  };

  const includesSearchText = (text) =>
    text.toLowerCase().includes(searchText.toLowerCase());

  const searchForMatch = (collection) =>
    publishedPageMapFilter(collection).some(({ title }) =>
      includesSearchText(title),
    );

  const filterForMatch = (collection) =>
    publishedPageMapFilter(collection).filter(({ title }) =>
      includesSearchText(title),
    );

  const results = publishedPageMapFilter(wm_page_map).filter(
    ({ name, sub_pages }) =>
      includesSearchText(name) || searchForMatch(sub_pages),
  );

  const navHeight = useMainHeight();

  return (
    <div className='wm-side-nav'>
      <SideNavSearch setShowMenu={setShowMenu} handleFilter={search} />
      <div className='abs-list-container' style={{ height: navHeight }}>
        <div className='list-container'>
          {results.length > 0 ? (
            <>
              {results.map(({ name, slug: pageMapSlug, sub_pages }, index) => {
                const isLanding = index === 0;
                if (sub_pages.length === 0) {
                  return (
                    <SideNavTitle
                      link={isLanding ? '/' : `/${pageMapSlug}`}
                      active={'' === pathNames[1]}
                      key={`sidenav-title-${index}`}
                    >
                      {name}
                    </SideNavTitle>
                  );
                } else {
                  return (
                    <SideNavDropdownMenu
                      title={name}
                      key={`sidenav-dropdown-menu-${index}`}
                      active={sub_pages.some(
                        ({ slug }) => slug === pathNames[0],
                      )}
                      searchActive={searchText !== ''}
                    >
                      {filterForMatch(sub_pages).map(
                        ({ slug, title, external_link, link }, index) => (
                          <SideNavMenuItem
                            key={`sidenav-menu-item-page-${index}`}
                            link={external_link ? link : `/${slug}`}
                            active={slug === pathNames[0]}
                            target={external_link ? '_blank' : ''}
                          >
                            {title}
                          </SideNavMenuItem>
                        ),
                      )}
                    </SideNavDropdownMenu>
                  );
                }
              })}
            </>
          ) : (
            <p className='no-results'>No Results Found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

WMSideNav.propTypes = {
  className: PropTypes.string,
  location: PropTypes.object,
  setShowMenu: PropTypes.func,
};

export default WMSideNav;
